module.exports = __webpack_public_path__ + "static/media/Envelop_01.c218cd92.jpg";